import React from 'react'
import { Col } from 'react-bootstrap'
import StatusBadge from '@components/common/StatusBadge/StatusBadge.component'
import { TrackerColumnProps } from '@dataTypes/patientTracker.types'

const TrackerColumn: React.FC<TrackerColumnProps> = ({
  title,
  count,
  bgColorClass,
  timeDuration,
  patientName,
  status,
  providerName,
  className,
}) => {
  const getEmptyText = (columnTitle: string): string => {
    switch (columnTitle) {
      case 'Scheduled':
        return 'No scheduled appointments.'
      case 'Checked-in':
        return 'No check-ins yet.'
      case 'In Treatment':
        return 'No patients in treatment yet.'
      case 'Discharged':
        return 'No completed appointments yet.'
      default:
        return 'No entries yet.'
    }
  }

  return (
    <Col
      md={3}
      className={`d-flex flex-column align-items-start text-start ${className}`}
    >
      <div className={`tracker-section w-100 h-100 ${bgColorClass}`}>
        <div className="d-flex align-items-center mb-2 ms-2 mt-2">
          <div className="tracker-title">{title}</div>
          <div className="tracker-count">{count}</div>
        </div>
        {timeDuration && patientName && status && providerName ? (
          <div className="tracker-container position-relative">
            <div className="tracker-time-duration">{timeDuration}</div>
            <div className="tracker-patient">{patientName}</div>
            <div className="tracker-patient-badge">
              <StatusBadge status={status} />
            </div>
            <div className="tracker-provider">{providerName}</div>
            <div className="tracker-options">
              <i className="bi bi-three-dots"></i>
            </div>
          </div>
        ) : (
          <div className="d-flex flex-column justify-content-center align-items-center h-100 w-100">
            <i className="ti ti-xbox-x-filled empty-icon"></i>
            <div className="tracker-empty-text">{getEmptyText(title)}</div>
          </div>
        )}
      </div>
    </Col>
  )
}

export default TrackerColumn
